import React, { useCallback, useMemo } from 'react'

import { bool, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import { PLAN_TYPE, TIER } from '../../constants'

const AI_CONSEQUENCE_KEYS = [
  'keep_access',
  'no_generations',
  'keep_license_ai',
  'no_fee_no_commitment',
]

function ConsequencesList({
  hasFee = false,
  planType = 'yearly',
  gracePeriodEligible = true,
  locale = 'en',
  tier = TIER.ESSENTIALS,
}) {
  const translate = useCallback(
    (key) => I18n.t(
      `subscription_management.cancel_modal.${key}`,
      { ns: 'rails', lng: locale }
    ),
    [locale]
  )

  // Fee terms differ per cohort: legacy (grace-period) subscribers keep the conditional
  // 45-day promise; the v1.6 yearly cohort has the same 45-day window plus a zero-downloads
  // waiver, so its terms are only stated when a fee is actually due (the no-fee banner
  // already covers the waived case); monthly plans never carry a fee.
  const feeNoticeKey = useMemo(() => {
    if (planType === PLAN_TYPE.MONTHLY) return null
    if (gracePeriodEligible) return 'fee_notice'

    return hasFee ? 'fee_notice_new_yearly' : null
  }, [planType, gracePeriodEligible, hasFee])

  const consequenceKeys = tier === TIER.AI_STUDIO
    ? AI_CONSEQUENCE_KEYS
    : [
      'keep_access',
      'no_downloads',
      'keep_license',
      ...(feeNoticeKey ? [feeNoticeKey] : []),
    ]

  return (
    <div className="cancel-subscription-modal__consequences">
      <h4 className="cancel-subscription-modal__consequences-title">
        {translate('consequences_title')}
      </h4>
      <ul className="cancel-subscription-modal__consequences-list">
        {consequenceKeys.map((key) => (
          <li
            key={key}
            className="cancel-subscription-modal__consequences-item cgt-text-medium"
          >
            {translate(`consequences.${key}`)}
          </li>
        ))}
      </ul>
    </div>
  )
}

ConsequencesList.propTypes = {
  hasFee: bool,
  planType: string,
  gracePeriodEligible: bool,
  locale: string,
  tier: string,
}

export default ConsequencesList
